import { dataPointScalarValue } from '../../../../DataPoint/util';
import { addMonetaryAmounts, subtractMonetaryAmounts } from '../../../../util';
import { Loan, MonetaryAmount, RealEstate } from '../../../../generated/graphql';

export const useRealEstateEquity = (realEstate: RealEstate, loans: Loan[]) => {
  const loanBalances = loans.map((loan) => dataPointScalarValue(loan.balance.latestDataPoint?.data) as MonetaryAmount);

  return subtractMonetaryAmounts(dataPointScalarValue(realEstate.value.latestDataPoint?.data) as MonetaryAmount, [
    addMonetaryAmounts(loanBalances),
  ]);
};
